import React from 'react';
import {SaveButton, Toolbar} from 'react-admin';

export const CustomCreateToolbar = props => (
  <Toolbar {...props} >
    <SaveButton disabled={props.pristine || props.invalid}/>
  </Toolbar>
);